export default __webpack_public_path__ + "img/logout.5ae48d.svg";